import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgxUiLoaderModule } from 'ngx-ui-loader';

@Component({
    selector: 'sp-loader',
    templateUrl: './sp-loader.component.html',
    styleUrls: ['./sp-loader.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxUiLoaderModule],
})
export class SpLoaderComponent {
    @Input() loaderId!: string;
}
